import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function isBMU() {
  const currentUrl = window.location.href;

  return currentUrl?.includes('bmu.virtul-learn') || currentUrl?.includes('3000');
}

export default isBMU;
